import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Button, AppHeader, AppHeaderBackButton, Typography } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { LoadingIndicator } from '../components/LoadingIndicator';
import gift_recipient_club_mismatch from '../assets/gift-recipient-club-mismatch.png';
import { UtagType } from '../utils/UtagHelper';
import { useHistory, useLocation } from 'react-router-dom';
import { Pages } from '@lib/types';
import { getNextPage } from '../utils/getNextPage';
import { stripNonWhitelistedQueryParams } from '../utils/helpers';

interface LocationState {
  isOutOfACETerritory?: boolean;
  zipCode: string;
}

export const GiftRecipientClubMismatch: React.FC = () => {
  const { loadingInfo, refreshSession, sessionData, sendTag } = useContext(MembershipAppStateContext);
  const [isTagging, setIsTagging] = useState(true);
  const [isTaggingSent, setIsTaggingSent] = useState(false);
  const isOutOfACETerritory: boolean = useLocation<LocationState>().state?.isOutOfACETerritory ?? false;
  const { queryString } = sessionData;
  const zipCode: string = useLocation<LocationState>().state?.zipCode;
  const history = useHistory();
  const errorMsg = isOutOfACETerritory
    ? 'membership:gift:knockout-recipient address out of ace territory'
    : 'membership:gift:knockout-recipient zip code out of market';

  useEffect(() => {
    refreshSession();
  }, []);

  useLayoutEffect(() => {
    if (!isTaggingSent) {
      sendTag(UtagType.view, 'membership:gift:knockout', { error: errorMsg });
      setIsTaggingSent(true);
    }
    setIsTagging(false);
  });

  const isLoading = loadingInfo.isLoading;
  if (isLoading) {
    return (
      <div>
        <AppHeader sx={{ padding: 0 }} />
        <LoadingIndicator loadingInfo={loadingInfo} maxSteps={0} currentStep={loadingInfo.loadingDetails.length} />
      </div>
    );
  }

  if (isTagging) {
    return <></>;
  }

  function findAAAClub() {
    const overrides = { cta: 'membership:join:knockout-recipient club mismatch' };
    sendTag(UtagType.link, 'knockout', overrides);
    window.open(`https://gift.aaa.com/`);
  }

  function redirectToLandingPage() {
    const currentUrl = window.location.href;
    const urlSearchParams = new URLSearchParams(queryString != null ? queryString : '');
    const zipCodeFromUrl: string | null = urlSearchParams.get('zipcode') ?? null;
    if (zipCodeFromUrl != null && zipCodeFromUrl != '') {
      urlSearchParams.set('zipcode', zipCode);
    }
    const params = urlSearchParams.toString();
    const urlWithWhiteListedParams = stripNonWhitelistedQueryParams(currentUrl, params);
    window.history.replaceState(null, '', urlWithWhiteListedParams);
    const benefitsURI = `${Pages.LandingPage}?${params}`;
    history.push(benefitsURI);
  }

  return (
    <>
      <div className="gift-recipient-page-view">
        <AppHeader sx={{ padding: 0 }} backButton={<AppHeaderBackButton />} />
        {loadingInfo.isLoading ? (
          <LoadingIndicator loadingInfo={loadingInfo} maxSteps={2} currentStep={loadingInfo.loadingDetails.length} />
        ) : (
          <>
            <div className="gift-recipient-container">
              <div className="gift-recipient-content-align">
                <img src={gift_recipient_club_mismatch} className="gift-recipient-icon" />
              </div>
              <Typography variant="h4" className="gift-recipient-title">
                Gift recipient is in an area covered by a different club
              </Typography>
              <Typography variant="b1Regular" className="gift-recipient-description">
                We'll help you find your gift recipient's AAA club for accurate pricing and benefits.
              </Typography>
            </div>
            <div className="gift-recipient-buttons">
              <Button
                label={isOutOfACETerritory ? 'Find AAA club' : 'Continue'}
                fullWidth
                onClick={isOutOfACETerritory ? findAAAClub : redirectToLandingPage}
                variant="contained"
                size="medium"
                id="findAAAClubButtonOrContinue"
              ></Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};
